'use client';

import Link from 'next/link';
import type { MouseEvent, PropsWithChildren } from 'react';

import { track } from '@/lib/analytics/events';

type PressCardLinkProps = PropsWithChildren<
  {
    slug: string;
    linkId?: string;
  } & React.ComponentProps<typeof Link>
>;

export default function PressCardLink({ slug, linkId, onClick, children, ...rest }: PressCardLinkProps) {
  const hrefValue =
    typeof rest.href === 'string'
      ? rest.href
      : typeof rest.href === 'object' && 'pathname' in rest.href
        ? String(rest.href.pathname)
        : `/press/${slug}`;

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event);
    track.nav({
      link_url: hrefValue,
      link_text: linkId ?? `press-card-${slug}`,
      section_id: 'press-list',
      section_title: 'Press list',
    });
  };

  return (
    <Link {...rest} onClick={handleClick}>
      {children}
    </Link>
  );
}
